export default "__VITE_ASSET__DII5Ryik__"